import React from 'react'
import CourseAttendanceCard from '../../common/component/cards/CourseAttendanceCard'

function Attendance() {
  return (
    <div className="adminShell__body--content">
      <CourseAttendanceCard />
    </div>
  )
}

export default Attendance